"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

exports.MinHash = function (_a) {
  var className = _a.className,
      value = _a.value,
      style = _a.style,
      _b = _a.size,
      size = _b === void 0 ? 6 : _b;
  return react_1.default.createElement("p", {
    className: classnames_1.default('mb-0 hash-overflow', className),
    style: __assign({}, style, {
      maxWidth: size + "em"
    })
  }, value);
};

exports.FullHash = function (_a) {
  var className = _a.className,
      value = _a.value,
      style = _a.style;
  return react_1.default.createElement("p", {
    className: classnames_1.default('mb-0 break-word', className),
    style: style
  }, value);
};

exports.default = function (_a) {
  var className = _a.className,
      value = _a.value,
      rest = __rest(_a, ["className", "value"]);

  return react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(exports.MinHash, __assign({
    className: classnames_1.default('d-md-none', className),
    value: value
  }, rest)), react_1.default.createElement(exports.FullHash, __assign({
    className: classnames_1.default('d-none d-md-block', className),
    value: value
  }, rest)));
};